export default {
  install: (app, { controllers, customControllers }) => {
    const api = {}

    const coreRequireFiles = require.context(
      './', true, /\.js$/
    )
    coreRequireFiles.keys().forEach(fileName => {
      addLib(app, api, fileName, coreRequireFiles)
    })
    controllers.keys().forEach(fileName => {
      addLib(app, api, fileName, controllers)
    })

    if (customControllers) {
      customControllers.forEach(p => {
        const name = p.controller
        delete p.controller
        api[name] = p
      })
    }

    app.prototype.$api = api
  }
}

function addLib (instance, api, fileName, files) {
  let libName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
  if (libName !== 'index') {
    const lib = files(fileName).default
    const parts = libName.split('/')
    libName = parts[parts.length - 1]

    switch (libName) {
      case 'util': libName = 'UTIL'
        break
      case 'ui': libName = 'UI'
        break
      case 'cep': libName = 'CEP'
        break
      case 'fipe': libName = 'FIPE'
        break
    }

    if (lib.controller) {
      libName = lib.controller
      delete lib.controller
    }

    // import libName from fileName
    lib.instance = instance
    lib.store = new instance({}).$store

    api[libName] = lib
  }
}
